let entitydbLa = {
    "pinned": [
      "CompanyName"
    ],
    "width": {
      "CompanyName": 240
    },
    "immutable": {
      "CompanyName": false
    },
    "mapping": {
      "CompanyName": {
        "header": "Company Name",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CompanyName"
      },
      "Status": {
        "header": "Company Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Status",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Active",
          "Dissolved",
          "In Liquidation",
          "Liquidated",
          "Struck Off"
        ]
      },
      "FundFamily": {
        "header": "Fund Family",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundFamily",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Fund I",
          "Fund II",
          "Fund III",
          "Fund IV",
          "Fund V",
          "Fund VI",
          "Fund VII"
        ]
      },
      "Purpose": {
        "header": "Entity Purpose",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Purpose",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "AIV",
          "AIV Yukon",
          "Blocker",
          "Carry Vehicle",
          "Co-Investment",
          "Comingled Fund",
          "Feeder Fund",
          "General Partner",
          "Management Company",
          "Parallel Fund",
          "Partner Vehicle",
          "Separate Account",
          "Side Car",
          "Sleeve Fund",
          "SPV"
        ]
      },
      "Country": {
        "header": "Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Country",
        "cellEditor": "agTextCellEditor"
      },
      "InitClose": {
        "header": "Initial Closing",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InitClose",
        "cellEditor": "agTextCellEditor"
      },
      "FinalCloseDate": {
        "header": "Final Closing",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FinalCloseDate",
        "cellEditor": "agTextCellEditor"
      },
      "InvStartDate": {
        "header": "Investment Period Start Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvStartDate",
        "cellEditor": "agTextCellEditor"
      },
      "InvEndDate": {
        "header": "Investment Period End Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvEndDate",
        "cellEditor": "agTextCellEditor"
      },
      "InvExtProvisions": {
        "header": "Extensions to Investment Period Provisions",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvExtProvisions",
        "cellEditor": "agTextCellEditor"
      },
      "InvExt1": {
        "header": "Investment period end date - extension 1",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvExt1",
        "cellEditor": "agTextCellEditor"
      },
      "InvExt2": {
        "header": "Investment period end date - extension 2",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvExt1",
        "cellEditor": "agTextCellEditor"
      },
      "InvExt3": {
        "header": "Investment period end date - extension 3",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvExt1",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerTerm": {
        "header": "Partnership Term",
        "rules": null,
        "dataType": "text",
        "element": "textarea",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerTerm",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerEndDate": {
        "header": "Partnership End Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerEndDate",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerTermExtProvisions": {
        "header": "Partnership Term Extensions Provisions",
        "rules": null,
        "dataType": "text",
        "element": "textarea",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerTermExtProvisions",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt1EndDate": {
        "header": "Partnership end date - extension 1",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt1EndDate",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt1Pursuant": {
        "header": "Extension 1 pursuant to",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt1Pursuant",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt2Date": {
        "header": "Partnership date - extension 2",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt2Date",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt2Pursuant": {
        "header": "Extension 2 pursuant to",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt2Pursuant",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt3Date": {
        "header": "Partnership date - extension 3",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt3Date",
        "cellEditor": "agTextCellEditor"
      },
      "PartnerExt3Pursuant": {
        "header": "Extension 3 pursuant to",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PartnerExt3Pursuant",
        "cellEditor": "agTextCellEditor"
      },
      "PrefReturn": {
        "header": "Preferred Return",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PrefReturn",
        "cellEditor": "agTextCellEditor"
      },
      "MFeePct": {
        "header": "Management Fee Percentage",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeePct",
        "cellEditor": "agTextCellEditor"
      },
      "MFeeStepVerb": {
        "header": "Management Fee Step Down Verbiage",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeStepVerb",
        "cellEditor": "agTextCellEditor"
      },
      "MFeeStepPct": {
        "header": "Management Fee Step-Down Percentage",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeStepPct",
        "cellEditor": "agTextCellEditor"
      },
      "MFeeStepStatus": {
        "header": "Is the management fee in step down?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeStepStatus",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No",
          "Not Applicable"
        ]
      },
      "MFeeStepDate": {
        "header": "Date of Step Down",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeStepDate",
        "cellEditor": "agTextCellEditor"
      },
      "MFeeStepReason": {
        "header": "Reason for Step Down",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeStepReason",
        "cellEditor": "agTextCellEditor"
      },
      "InvAmtExclusions": {
        "header": "Invested Amount Exclusions",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvAmtExclusions",
        "cellEditor": "agTextCellEditor"
      },
      "MFeeWaiverProvisions": {
        "header": "Management Fee Waiver Provisions",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MFeeWaiverProvisions",
        "cellEditor": "agTextCellEditor"
      },
      "CarryPct": {
        "header": "Carry Percent",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CarryPct",
        "cellEditor": "agTextCellEditor"
      },
      "CarryTerms": {
        "header": "Carry Terms",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CarryTerms",
        "cellEditor": "agTextCellEditor"
      },
      "AggCapCommit": {
        "header": "Aggregate Capital Commitments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AggCapCommit",
        "cellEditor": "agTextCellEditor"
      },
      "LPCommit": {
        "header": "Total LP Commitments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LPCommit",
        "cellEditor": "agTextCellEditor"
      }, 
      "GPCommit": {
        "header": "Total GP Commitments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "GPCommit",
        "cellEditor": "agTextCellEditor"
      },
      "BalCoEntity": {
        "header": "Balanced/Co-Invest (Multiple Tranche) Entity?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "BalCoEntity",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Balanced Only",
          "Co-Investment Only",
          "Balanced/Co-Investment",
          "Multiple Tranches",
          "Balanced/Co-Investment & Multiple Tranches",
          "Not Applicable"
        ]
      },
      "BalCommit": {
        "header": "Total Balanced Commitment",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "BalCommit",
        "cellEditor": "agTextCellEditor"
      },
      "CoCommit": {
        "header": "Total Co-Invest Commitment",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CoCommit",
        "cellEditor": "agTextCellEditor"
      },
      "Tranche1Commit": {
        "header": "Tranche 1 Commitment",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Tranche1Commit",
        "cellEditor": "agTextCellEditor"
      },
      "Tranche2Commit": {
        "header": "Tranche 2 Commitment",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Tranche2Commit",
        "cellEditor": "agTextCellEditor"
      },
      "AddCommit": {
        "header": "Additional Commitments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddCommit",
        "cellEditor": "agTextCellEditor"
      }, 
      "ExcessOrgExpCap": {
        "header": "Excess Organizational Expense Cap?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ExcessOrgExpCap",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No",
          "Not Applicable"
        ]
      }, 
      "ExcessOrgExpAmt": {
        "header": "Excess Organizational Expense Amount",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ExcessOrgExpAmt",
        "cellEditor": "agTextCellEditor"
      },
      "CapCallPeriod": {
        "header": "Capital call notification period",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CapCallPeriod",
        "cellEditor": "agTextCellEditor"
      },
      "BorrowLimit": {
        "header": "Limitations on borrowing",
        "rules": null,
        "dataType": "text",
        "element": "textarea",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "BorrowLimit",
        "cellEditor": "agTextCellEditor"
      }, 
      "PreNoticeBorrowList": {
        "header": "Who requires pre-notice of borrowing?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "PreNoticeBorrowList",
        "cellEditor": "agTextCellEditor"
      },
      "MoneyMktAcctRestrict": {
        "header": "Restrictions on money market accounts?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "MoneyMktAcctRestrict",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No",
          "Not Applicable"
        ]
      }, 
      "InvRestrict": {
        "header": "Investment restrictions",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "InvRestrict",
        "cellEditor": "agTextCellEditor"
      },
      "Amend1": {
        "header": "Amendment 1 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend1",
        "cellEditor": "agTextCellEditor"
      },
      "Amend2": {
        "header": "Amendment 2 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend2",
        "cellEditor": "agTextCellEditor"
      },
      "Amend3": {
        "header": "Amendment 3 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend3",
        "cellEditor": "agTextCellEditor"
      },
      "Amend4": {
        "header": "Amendment 4 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend4",
        "cellEditor": "agTextCellEditor"
      },
      "Amend5": {
        "header": "Amendment 5 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend5",
        "cellEditor": "agTextCellEditor"
      },
      "Amend6": {
        "header": "Amendment 6 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend6",
        "cellEditor": "agTextCellEditor"
      },
      "Amend7": {
        "header": "Amendment 7 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend7",
        "cellEditor": "agTextCellEditor"
      },
      "Amend8": {
        "header": "Amendment 8 to LPA/LLC",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Amend8",
        "cellEditor": "agTextCellEditor"
      }      
    }
  }
  export  { entitydbLa }
  